import { render, staticRenderFns } from "./WhyPage.vue?vue&type=template&id=81473f2c&scoped=true"
var script = {}
import style0 from "./WhyPage.vue?vue&type=style&index=0&id=81473f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81473f2c",
  null
  
)

export default component.exports